export default __webpack_public_path__ + "static/media/martin_santander.cb8b1056.png";